"use client";

import { useEffect } from "react";
import { capturePostHogEvent } from "@/lib/posthog";

interface PageViewTrackerProps {
  event: string;
  properties?: Record<string, unknown>;
}

export function PageViewTracker({ event, properties }: PageViewTrackerProps) {
  useEffect(() => {
    capturePostHogEvent(event, properties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
